import React from 'react'
import {Alert, IconButton, Stack} from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import './index.scss'
import CloseIcon from '@mui/icons-material/Close'

interface CPSAlertsProps {
    behaviour?: string
    type?: any
    title?: string
    message?: any
    variant?: any
    isClosable?: boolean
    toggleAlertDisplay?(...args: unknown[]): unknown
}

const CPSAlerts = ({
    behaviour = 'fixed',
    type,
    title,
    message,
    variant,
    isClosable,
    toggleAlertDisplay
}: CPSAlertsProps) => (
    <Stack sx={{width: '100%'}} spacing={2} className='alertWrapper'>
        <Alert
            severity={type}
            variant={variant || 'standard'}
            className={behaviour === 'floating' ? 'floatinAlert' : 'fixedAlert'}
            iconMapping={{
                success: <CheckCircleOutlineIcon fontSize='inherit' />
                // info: <CheckCircleOutlineIcon fontSize='inherit' />
            }}
        >
            {title}
            {message}
            {isClosable && (
                <div className='closeButton'>
                    <IconButton aria-label='delete' onClick={toggleAlertDisplay}>
                        <CloseIcon fontSize='small' />
                    </IconButton>
                </div>
            )}
        </Alert>
    </Stack>
)

CPSAlerts.defaultProps = {
    behaviour: 'fixed',
    type: 'error',
    title: '',
    message: '',
    variant: 'standard',
    isClosable: false,
    toggleAlertDisplay: () => {}
}

export default CPSAlerts
